// Shared helpers for section CRUD sections.
import { useCallback, useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";

export function useCollection(tripId, name, onChange) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/trips/${tripId}/${name}`);
      setItems(data);
    } catch (e) { toast.error(formatError(e)); }
    finally { setLoading(false); }
  }, [tripId, name]);

  useEffect(() => { load(); }, [load]);

  async function create(payload) {
    const { data } = await api.post(`/trips/${tripId}/${name}`, payload);
    setItems((it) => [...it, data]);
    onChange?.();
    return data;
  }
  async function update(id, payload) {
    const { data } = await api.put(`/trips/${tripId}/${name}/${id}`, payload);
    setItems((it) => it.map((x) => (x.id === id ? data : x)));
    onChange?.();
    return data;
  }
  async function remove(id) {
    await api.delete(`/trips/${tripId}/${name}/${id}`);
    setItems((it) => it.filter((x) => x.id !== id));
    onChange?.();
  }

  return { items, loading, create, update, remove, reload: load };
}
